// Single source of truth for "is this the live production site?".
// GA4, PostHog and RB2B all use this so production is defined in one place.

const PRODUCTION_HOSTS = ['thefamousgroup.com', 'www.thefamousgroup.com'] as const;

export function isProductionHost(): boolean {
  if (typeof window === 'undefined') return false;
  return (PRODUCTION_HOSTS as readonly string[]).includes(window.location.hostname);
}

export function environment(): 'production' | 'preview' | 'development' {
  if (isProductionHost()) return 'production';
  const host = typeof window === 'undefined' ? '' : window.location.hostname;
  if (host.endsWith('lovable.app')) return 'preview';
  return 'development';
}
